import React from 'react'
import { View, Text } from '@react-pdf/renderer';
import moment from 'moment'

export const RelatorioChecklistOperacaoTemperatura = ({ dias, checklistOperacaoItem, i, styles, respostaChecklistOperacao }) => {

  function getTemperatura1(index, codigo, data) {
    if (respostaChecklistOperacao && respostaChecklistOperacao.respostaChecklistOperacao && respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index] && respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index].length > 0) {
      const itemRespostaChecklistOperacao = respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index].find(p => moment(p.dataHora, "YYYY-MM-DD").isSame(moment(data, "YYYY-MM-DD")));
      if (itemRespostaChecklistOperacao) {
        if (itemRespostaChecklistOperacao && itemRespostaChecklistOperacao.respostasChecklistsOperacaoTemperatura.length > 0) {
          const item = itemRespostaChecklistOperacao.respostasChecklistsOperacaoTemperatura.find(p => p.idChecklistOperacaoItem == codigo);
          if (item && item.temperatura1) {
            return item.temperatura1 + 'ºC';
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  function getTemperatura2(index, codigo, data) {
    if (respostaChecklistOperacao && respostaChecklistOperacao.respostaChecklistOperacao && respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index] && respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index].length > 0) {
      const itemRespostaChecklistOperacao = respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index].find(p => moment(p.dataHora, "YYYY-MM-DD").isSame(moment(data, "YYYY-MM-DD")));
      if (itemRespostaChecklistOperacao) {
        if (itemRespostaChecklistOperacao && itemRespostaChecklistOperacao.respostasChecklistsOperacaoTemperatura.length > 0) {
          const item = itemRespostaChecklistOperacao.respostasChecklistsOperacaoTemperatura.find(p => p.idChecklistOperacaoItem == codigo);;
          if (item && item.temperatura2) {
            return item.temperatura2 + 'ºC';
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  return (
    <View>
      <View fixed={false} key={i} style={{ marginTop: 10 }}>
        <View style={styles.row} >
          <View style={[styles.header, { width: 245, border: 0 }]}>
            <Text></Text>
          </View>
          {
            (
              undefined !== dias && dias.length ?
                dias.map((dia) =>
                  <View key={dia} style={[styles.header, { width: 79.4 }]}>
                    <Text>{moment(dia).format('DD/MM/YYYY')}</Text>
                  </View>
                )
                :
                null
            )
          }
        </View>

        <View style={[styles.row, { marginTop: 0 }]} key={i} >
          <View style={[styles.header, { width: 245 }]}>
            <Text>Item</Text>
          </View>

          {
            (
              undefined !== dias && dias.length ?
                dias.map((dia, i) =>
                  <>
                    <View>
                      <View style={{ flexDirection: 'row' }}>
                        <View style={[styles.cellSmall, { width: 38, fontFamily: 'Roboto', marginHorizontal: 1, height: 18 }]}>
                          <Text>Temp.</Text>
                          <Text>Manhã</Text>
                        </View>
                        <View style={[styles.cellSmall, { width: 38, fontFamily: 'Roboto', marginHorizontal: 1, height: 18 }]}>
                          <Text>Temp.</Text>
                          <Text>Noite</Text>
                        </View>
                      </View>
                    </View>
                  </>
                )
                :
                null
            )
          }
        </View>
      </View>

      {
        (checklistOperacaoItem[i] !== undefined && checklistOperacaoItem[i].checklistsOperacaoItens !== undefined && checklistOperacaoItem[i].checklistsOperacaoItens.length > 0 && undefined !== dias && dias.length) ?
          checklistOperacaoItem[i].checklistsOperacaoItens.map((n, index) => {
            return (
              <View wrap={false} style={{ 'backgroundColor': (index % 2 == 0 ? '#E8E8E8' : '#FFFFFF') }}>
                <View style={[styles.rowTop, styles.rowBottom]} key={n.id}>
                  <View style={[styles.cell, { width: 245 }]}>
                    <Text>{n.descricao}</Text>
                  </View>

                  {
                    dias.map((dia, i) =>
                      <>
                        <View style={[styles.cellSpace, { borderRight: dias.length - 1 != i ? 1 : 0 }]}>
                          <View style={[styles.cellSmall, { width: 35, marginHorizontal: 1 }]}>
                            <Text>{getTemperatura1(n.idChecklistOperacao, n.id, dia)}</Text>
                          </View>
                          <View style={[styles.cellSmall, { width: 35, marginHorizontal: 1 }]}>
                            <Text>{getTemperatura2(n.idChecklistOperacao, n.id, dia)}</Text>
                          </View>
                        </View>
                      </>
                    )
                  }

                </View>

              </View>



            );
          })
          : null
      }

    </View>

  );
};
